export function isValidHostname(hostname: string): boolean {
  const hostPattern = /^[a-z0-9][a-z0-9\.\-]*[a-z0-9]$/;
  return hostPattern.test(hostname);
}



// WEBPACK FOOTER //
// ../isValidHostname.ts